import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Records/hooks/useRecordComments.ts
var useRecordComments = (args, opts = {}) => {
	const { call, data, isCalling } = useRPC(RPCs.Records.GetRecordComments.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args?.recordId
	});
	return {
		call,
		data,
		loading: isCalling
	};
};
//#endregion
export { useRecordComments };

//# sourceMappingURL=useRecordComments.js.map